module.exports = __webpack_public_path__ + "media/LindaEdmondsTurnerQuote.6a64d436.mp3";